<template>
    <div class="accordion-item" :class="[bemIf(isItemOpen, 'open'), bemFacets]">
        <div class="accordion-item--container">
            <div class="accordion-item--row">
                <div class="accordion-item--col">
                    <div class="accordion-item--title-wrapper" tabindex="0" @click="onOpen">
                        <slot name="title">
                            <h3 class="u-reset accordion-item--title">{{ label }}</h3>
                        </slot>

                        <div class="accordion-item--indicator-col">
                            <button class="u-reset accordion-item--indicator">
                                <slot name="icon">
                                    <base-icon symbol="chevron-down" size="small"/>
                                </slot>
                            </button>
                        </div>
                    </div>

                    <transition
                            name="trs-accordion"
                            @before-enter="beforeEnter"
                            @enter="enter"
                            @before-leave="beforeLeave"
                            @leave="leave"
                    >
                        <div class="accordion-item--content" v-show="isItemOpen">
                            <slot name="content">
                                <div class="u-raw-text" v-html="content"/>
                            </slot>
                            <slot/>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('accordion-item')],
        props: {
            label: {
                type: String,
                default: null,
            },

            content: {
                type: String,
                default: null,
            },

            isOpen: {
                type: Boolean,
                default: false,
            },

            standalone: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isActive: false,
            };
        },

        computed: {
            isItemOpen() {
                return this.isOpen || (this.standalone && this.isActive);
            },
        },

        methods: {
            beforeEnter: function(el) {
                el.style.height = '0';
            },

            enter: function(el) {
                el.style.height = `${ el.scrollHeight }px`;
            },

            beforeLeave: function(el) {
                el.style.height = `${ el.scrollHeight }px`;
            },

            leave: function(el) {
                el.style.height = '0';
            },

            onOpen() {
                this.isActive = !this.isActive;

                if (this.isActive) {
                    this.$emit('open');
                } else {
                    this.$emit('close');
                }
            },
        },

        watch: {
            isOpen(val) {
                if (val === false) {
                    this.isActive = false;
                }

                if (val) {
                    this.$emit('open');
                }
            },
        },

        mounted() {
            this.isActive = this.isOpen;
        },
    };
</script>
